import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import { definePreset } from '@primevue/themes';

import Tooltip from 'primevue/tooltip';
import Drawer from 'primevue/drawer';
import Dialog from 'primevue/dialog';

export function initPrimevue(app: any): void {
  app.use(PrimeVue, {
    theme: {
      preset: definePreset(Aura, {
        semantic: {
          primary: {
            50: '{green.50}',
            100: '{green.100}',
            200: '{green.200}',
            300: '{green.300}',
            400: '{green.400}',
            500: '#23DB85',
            600: '{green.600}',
            700: '{green.700}',
            800: '{green.800}',
            900: '{green.900}',
            950: '{green.950}',
          },
        },
      }),
      options: {
        darkModeSelector: '.fake-dark-selector', // trying to also force a non-usage of the dark mode
        cssLayer: {
          name: 'primevue', // the name of the layer PrimeVue will create
          order: 'tailwind-base, meridia-components, primevue',
        },
      },
    },
  });

  app.directive('tooltip', Tooltip);
  app.component('p-drawer', Drawer);
  app.component('p-dialog', Dialog);
}

// TypeScript declaration for global components
// declare module 'vue' {
//   export interface GlobalComponents {
//     //
//   }
// }
